export const transformData = (data: string) => {
  const [month, year] = data.split(' ');
  const date = new Date(Number(year), Number(month) - 1);

  const formatter = new Intl.DateTimeFormat('ru-RU', {
    month: 'short',
    year: 'numeric',
  });

  const result = formatter.format(date);

  return result;
};
